export default __webpack_public_path__ + "static/media/pic1.6d5a27e4.jpg";